import { Divider, Text } from "react-native-paper";
import type { IconType } from "../../../../icon";
import { useAppTheme } from "../../../../useAppTheme";
import { AppIcon } from "../../../AppIcon";
import Box from "../../../Box";
import { PreTestCard } from "./PreTestCard";
import { PreTestTable } from "./PreTestTable";

export type TestFormatPartRow = {
	part: string;
	content: string;
	timeAllowed: string;
};

export type TestFormatContent = {
	title?: string;
	intro: string;
	parts: TestFormatPartRow[];
	timerTitle: string;
	timerDescription: string;
	timerIcon?: IconType;
};

type Props = TestFormatContent;

const TestFormat = ({
	title = "Test Format",
	intro,
	parts,
	timerTitle,
	timerDescription,
	timerIcon = "clock-outline",
}: Props) => {
	const theme = useAppTheme();

	return (
		<PreTestCard title={title}>
			<Text variant="bodyLarge">{intro}</Text>

			<PreTestTable
				columns={[
					{ label: "Part" },
					{ label: "Content" },
					{ label: "Time Allowed" },
				]}
				rows={parts.map((row) => [row.part, row.content, row.timeAllowed])}
			/>

			<Divider />

			<Box gap={8}>
				<Box flexDirection="row" alignItems="center" gap={8}>
					<AppIcon name={timerIcon} size={24} color={theme.colors.primary} />
					<Text variant="bodyLarge">{timerTitle}</Text>
				</Box>
				<Text
					variant="bodyMedium"
					style={{ color: theme.colors.inverseSurface }}
				>
					{timerDescription}
				</Text>
			</Box>
		</PreTestCard>
	);
};

export default TestFormat;
